import { render, staticRenderFns } from "./tindex.vue?vue&type=template&id=ad9073d0&"
import script from "./tindex.vue?vue&type=script&lang=js&"
export * from "./tindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports